var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackageSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 460 460",
    style: {
      enableBackground: "new 0 0 460 460"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEE187"
    },
    d: "M230,0C102.974,0,0,102.975,0,230c0,114.582,83.788,209.594,193.436,227.109l266.556-225.143 c0.006-0.655,0.008-1.31,0.008-1.966C460,102.975,357.025,0,230,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC61B"
    },
    d: "M459.975,231.966L368.26,140.25L56.088,319.75l137.345,137.345C205.343,458.998,217.554,460,230,460 C356.368,460,458.917,358.084,459.975,231.966z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#71E2F0"
    },
    points: "188.762,214.391 212.175,409.5 368.262,319.75 368.262,140.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "350.308,273.466 350.308,309.366 292.949,342.349 292.949,306.449 321.921,279.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C2FBFF"
    },
    points: "350.308,255.516 350.308,273.466 292.949,306.449 292.949,288.499  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C2FBFF"
    },
    points: "212.175,206.587 212.175,409.5 56.088,319.75 56.088,140.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#71E2F0"
    },
    points: "56.086,140.25 110.649,171.623 214.025,141.249 266.732,81.868 212.173,50.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#38C6D9"
    },
    points: "157.618,198.63 212.173,230 368.259,140.25 313.707,108.875 209.565,139.687  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "157.618,276.672 110.649,249.666 110.649,171.623 155.923,175.159 157.618,198.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C2FBFF"
    },
    points: "110.649,171.623 266.732,81.868 313.707,108.875 157.618,198.63  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF0F27"
    },
    d: "M258.413,271.923c0,18.909,6.794,36.228,18.068,49.66l59.225,70.574L360,293.393l-24.294-98.764 C293.019,194.629,258.413,229.235,258.413,271.923z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2001B"
    },
    d: "M335.707,194.629v197.528l59.225-70.574C406.207,308.151,413,290.831,413,271.923 C413,229.235,378.395,194.629,335.707,194.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2FBFF"
    },
    d: "M335.709,234.63c20.597,0,37.291,16.694,37.291,37.291s-16.694,37.299-37.291,37.299l-15.771-37.299 L335.709,234.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M335.709,234.63v74.59c-20.597,0-37.299-16.702-37.299-37.299S315.112,234.63,335.709,234.63z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageSvgrepoCom);
export default __webpack_public_path__ + "static/media/package-svgrepo-com.b70dacb539bda30b7e1dcad061277190.svg";
export { ForwardRef as ReactComponent };